import { render, staticRenderFns } from "./delConfirm.vue?vue&type=template&id=6c89e094&scoped=true&"
import script from "./delConfirm.vue?vue&type=script&lang=ts&"
export * from "./delConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./delConfirm.vue?vue&type=style&index=0&id=6c89e094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89e094",
  null
  
)

export default component.exports